<script lang="ts">
  import type { Grade } from '../../shared/contract'

  /**
   * A Canadian trail sign in CSS alone: green circle, blue square, black
   * diamond, two diamonds. Closed runs get the same shape as an outline. A run
   * the report gave no known grade gets a small neutral dot.
   */
  let {
    grade,
    off = false,
    wide = false,
  }: { grade?: Grade | null; off?: boolean; wide?: boolean } = $props()
</script>

{#if wide}
  <span class="gw"><i class="g {grade ?? 'none'}" class:off aria-hidden="true"></i></span>
{:else}
  <i class="g {grade ?? 'none'}" class:off aria-hidden="true"></i>
{/if}

<style>
  .g {
    position: relative;
    display: inline-block;
    flex: none;
    width: 11px;
    height: 11px;
    vertical-align: middle;
  }
  .green {
    border-radius: 50%;
    background: var(--green);
  }
  .blue {
    width: 10px;
    height: 10px;
    margin: 0.5px;
    background: var(--blue);
    border-radius: 1px;
  }
  .black::before,
  .double::before,
  .double::after {
    content: '';
    position: absolute;
    top: 1.5px;
    left: 1.5px;
    width: 8px;
    height: 8px;
    background: var(--diamond);
    transform: rotate(45deg);
    border-radius: 0.5px;
  }
  .double {
    width: 19px;
  }
  .double::after {
    left: 9.5px;
  }
  .none::before {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: var(--ink-2);
  }
  .off.green {
    background: none;
    box-shadow: inset 0 0 0 1.5px var(--green);
  }
  .off.blue {
    background: none;
    box-shadow: inset 0 0 0 1.5px var(--blue);
  }
  .off::before,
  .off::after {
    background: none;
    box-shadow: inset 0 0 0 1.5px var(--diamond);
  }
  .off.none::before {
    box-shadow: inset 0 0 0 1.5px var(--ink-3);
  }
  .double.off::after {
    background: var(--bg);
  }
  .gw {
    width: 19px;
    display: inline-flex;
    justify-content: center;
    flex: none;
  }
</style>
